<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->

<template>
  <xrd-confirm-dialog
    accept-button-text="tokens.logout.confirmButton"
    title="tokens.logout.title"
    text="tokens.logout.text"
    focus-on-accept
    :loading="loading"
    @cancel="cancel"
    @accept="confirmLogout"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { mapActions } from 'pinia';
import { useNotifications } from '@/store/modules/notifications';
import { useToken } from '@/store/modules/tokens';
import { Token } from '@/openapi-types';

export default defineComponent({
  props: {
    token: {
      type: Object as PropType<Token>,
      required: true,
    },
  },
  emits: ['cancel', 'token-logout'],
  data() {
    return {
      showConfirmLogout: false,
      loading: false,
    };
  },
  methods: {
    ...mapActions(useNotifications, ['showError', 'showSuccess']),
    ...mapActions(useToken, ['logoutToken']),
    cancel(): void {
      this.$emit('cancel');
    },
    confirmLogout(): void {
      this.loading = true;
      this.logoutToken(this.token.id)
        .then(() => {
          this.showSuccess(this.$t('tokens.logout.success'));
          this.$emit('token-logout');
        })
        .catch((error) => {
          this.showError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
</script>

<style lang="scss" scoped></style>
